namespace TabAurous {
    export interface ProcessRequest extends Serenity.ListRequest {
        ProcessTypeId?: number[];
        ProcessCode?: string;
    }
}
